import { Form, Modal } from 'antd'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import { TTSelect } from '../../shared/TTSelect'
import { TTSimpleModalProps } from '../../shared/TTModalProps'
import { TTFormItem } from '../../shared/TTFormItem'
import { renderSelectKeyValue } from '../../shared/SelectOptionRenderUtils'

import { RuoloClienteInputModel, RuoloClienteViewModel } from '../../../models/UtenteModels'
import { UtenteParams } from './../UtenteParams'
import { FormInstance } from 'antd/lib/form'


interface ModalContentClienteRoleProps extends TTSimpleModalProps {
    title: string
    hasCliente: boolean
    hasUfficio: boolean 
    onLoad: () => Promise<RuoloClienteViewModel>
    onSave: (data: RuoloClienteInputModel) => void
    clienteId?: string
    ufficioId?: string
}

class ModalContentClienteRoleState extends RuoloClienteViewModel {

}

export class ModalContentClienteRoleComp extends React.Component<RouteComponentProps<UtenteParams> & ModalContentClienteRoleProps, ModalContentClienteRoleState> {

    formRef = React.createRef<FormInstance>()

    constructor(props) {
        super(props)
        this.state = new ModalContentClienteRoleState()
    }

    static defaultProps = {
        hasCliente: false
    }

    componentDidMount() {
        this.load()
    }

    load = async () => {
        let resp = await this.props.onLoad()
        if (resp.IsValid == true)
            this.setState(resp)
    }

    onOk = async () => {
        try {
            let data = await this.formRef.current.validateFields()
            var model = new RuoloClienteInputModel()
            model.IdUtente = this.props.match.params.id
            model.Cliente = data["Cliente"]
            model.Ruolo = data["Ruolo"]
            model.Ufficio = data["Ufficio"]
            await this.props.onSave(model)
        } catch {

        }
    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    renderCliente = () => {
        if (this.props.hasCliente == false) return

        return (
            <TTFormItem name="Cliente" label="Cliente" rules={[{ required: true }]}>
                <TTSelect disabled={this.props.clienteId != null}>
                    {renderSelectKeyValue(this.state.ClientiList)}
                </TTSelect>
            </TTFormItem>
        )
    }

    renderUfficio = () => {
        if (this.props.hasUfficio == false) return

        return (
            <TTFormItem name="Ufficio" label="Ufficio" rules={[{ required: true }]}>
                <TTSelect disabled={this.props.ufficioId != null}>
                    {renderSelectKeyValue(this.state.UfficiList)}
                </TTSelect>
            </TTFormItem>
        )
    }

    render() {
        return (
            <Modal
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.closeModal}
                onOk={this.onOk}>
                <Form ref={this.formRef}
                    initialValues={{ Cliente: this.props.clienteId , Ufficio: this.props.ufficioId }}>
                    <TTFormItem name="Ruolo" label="Ruolo" rules={[{ required: true }]}>
                        <TTSelect>
                            {renderSelectKeyValue(this.state.RuoloList)}
                        </TTSelect>
                    </TTFormItem>
                    {this.renderCliente()}
                    {this.renderUfficio()}
                </Form>
            </Modal>
        )
    }
}

export const ModalContentClienteRole = withRouter(ModalContentClienteRoleComp)